import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=8d2b95e4&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=8d2b95e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2b95e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2b95e4')) {
      api.createRecord('8d2b95e4', component.options)
    } else {
      api.reload('8d2b95e4', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=8d2b95e4&scoped=true&", function () {
      api.rerender('8d2b95e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/PageHeader.vue"
export default component.exports